module.exports = __webpack_public_path__ + "img/theme-6-blue.49e08b5b.svg";